import { render, staticRenderFns } from "./Privacidad.vue?vue&type=template&id=4bd62544&scoped=true"
import script from "./Privacidad.vue?vue&type=script&lang=js"
export * from "./Privacidad.vue?vue&type=script&lang=js"
import style0 from "./Privacidad.vue?vue&type=style&index=0&id=4bd62544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd62544",
  null
  
)

export default component.exports